import React,{useState} from 'react'
import {Link} from "react-router-dom";
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
import axios from "../helper/axios";

export default function AddStatus() { 
  const [statusName,setStatusName] = useState("");
  const [statusColor,setStatusColor] = useState("");
  const [statusTextColor,setStatusTextColor] = useState("");
  const [statusDesc,setStatusDesc] = useState("");

  const addStatus=async()=>{
        const data = {statusName,statusColor,statusTextColor,statusDesc}
        const res = await axios.post("/addstatus",data)
        if(res.status===200){
          alert("Status Added");
        }
  }

	return (
	<div className="sidebar-mini skin-green-light">
		<div className="wrapper"> 
  		  <Header/> 
  		  <Sidebar/>
         
  {/* Content Wrapper. Contains page content */}
  <div className="content-wrapper">
    {/* Content Header (Page header) */}
    <section className="content-header">
      <h1>
        Add New Status 
      </h1>
      {/*<ol className="breadcrumb">
        <li>
          <a href="#">
            <i className="fa fa-dashboard" /> Home
          </a>
        </li>
        <li>
          <a href="#">Product Manage</a>
        </li>
        <li className="active">All Product</li>
      </ol>*/}
    </section>
    {/* Main content */}
    <section className="content">
      {/* Default box */}
      <div className="box">
        <div className="box-header with-border"> 
          <div className="box-tools pull-right">
            <Link
              to="/statuslist"
              type="button"
              className="btn btn-success"
              data-toggle="tooltip"
              title="View"
            >
              <i className="fa fa-eye" />
              {" View Status List "}
            </Link>
            {" "} 
          </div>
        </div>
        <div className="box-body">
        <div className="col-md-6">
         
   
  <div className="box-body">
    <div className="row">
      <div className="col-xs-12">
      <p className="text-normal">Status Name</p>
        <input type="text" className="form-control" onChange={(e)=>setStatusName(e.target.value)}/>
      </div> 
    </div>
  </div> 
  <div className="box-body">
    <div className="row">

      <div className="col-xs-12">
        <p className="text-normal">Status Color</p>
        <input type="color" className="form-control" placeholder="Price" onChange={(e)=>setStatusColor(e.target.value)}/>
      </div>  
    </div>
  </div>
  <div className="box-body">
    <div className="row">

      <div className="col-xs-12">
        <p className="text-normal">Status Text Color</p>
        <input type="color" className="form-control" onChange={(e)=>setStatusTextColor(e.target.value)}/>
      </div>  
    </div>
  </div>
  <div className="box-body">
    <div className="row">
      <div className="col-xs-12">
        <textarea type="number" min="0" max="80" className="form-control" placeholder="Description" onChange={(e)=>setStatusDesc(e.target.value)}/>
      </div> 
    </div>
  </div>
  <div className="box-body">
    <div className="row">
      <div className="col-xs-12">
        <button className="btn btn-primary" onClick={(e)=>addStatus()}>Add Status</button>
      </div> 
    </div>
  </div>
  {/* /.box-body */}
 
</div>
        

        	
        </div>

        {/* /.box-body */}
        {/*<div className="box-footer">Footer</div>*/}
        {/* /.box-footer*/}
      </div>
      {/* /.box */}
    </section>
    {/* /.content */}
  </div>
  {/* /.content-wrapper */}
 


       <Footer/>
       <Tool/> 
   
  <div className="control-sidebar-bg" />
</div>

			
		</div>
	)
}